"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseErrorKey = void 0;
var BaseErrorKey;
(function (BaseErrorKey) {
    BaseErrorKey["alreadyAssociatedRecordsError"] = "ALREADY_ASSOCIATED_RECORDS_ERROR";
    BaseErrorKey["associationActionMethodNotFoundError"] = "ASSOCIATION_ACTION_METHOD_NOT_FOUND_ERROR";
    BaseErrorKey["configNotFound"] = "CONFIG_NOT_FOUND";
    BaseErrorKey["dataValidationError"] = "DATA_VALIDATION_ERROR";
    BaseErrorKey["duplicateKeyError"] = "DUPLICATE_KEY_FOUND_ERROR";
    BaseErrorKey["entityNotFoundError"] = "ENTITY_NOT_FOUND_ERROR";
    BaseErrorKey["facebookError"] = "FACEBOOK_ERROR";
    BaseErrorKey["fileTooBig"] = "FILE_TOO_BIG";
    BaseErrorKey["googleError"] = "GOOGLE_ERROR";
    BaseErrorKey["invalidModelNameError"] = "INVALID_MODEL_NAME_ERROR";
    BaseErrorKey["multipleRecordsFoundError"] = "MULTIPLE_RECORDS_FOUND_ERROR";
    BaseErrorKey["notAssociatedRecordsError"] = "NOT_ASSOCIATED_RECORDS_ERROR";
    BaseErrorKey["paymentError"] = "PAYMENT_ERROR";
    BaseErrorKey["requestValidationError"] = "REQUEST_VALIDATION_ERROR";
    BaseErrorKey["responseError"] = "RESPONSE_ERROR";
    BaseErrorKey["syntaxError"] = "SYNTAX_ERROR";
    BaseErrorKey["unauthenticatedError"] = "UNAUTHENTICATED_ERROR";
    BaseErrorKey["unknownError"] = "UNKNOWN_ERROR";
    BaseErrorKey["unsetConfigParamsError"] = "UNSET_CONFIG_PARAMS_ERROR";
})(BaseErrorKey || (exports.BaseErrorKey = BaseErrorKey = {}));
